import React, { useState } from "react"
import { Button, Checkbox, Form, Input } from "antd"
import AuthService from "src/services/AuthService"
import { getStorage, setStorage, setStorageCookie } from "src/lib/storage"
import STORAGE from "src/lib/storage"
import { useLocation, useNavigate } from "react-router-dom"
import ROUTER from "src/router"
import { BlockInput, ButtonStyle } from "src/pages/ANONYMOUS/LoginPage/styled"
import SvgIcon from "src/components/SvgIcon"
import { setMenuType } from "src/redux/menuSlice"
import { useSelector, useDispatch } from "react-redux"

const LoginForm = ({ onClose, record, setActiveTab, selectedPackage }) => {
  const [loading, setLoading] = useState(false)

  const [form] = Form.useForm()
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { currentType } = useSelector(state => state.menu)
  const onLogin = async () => {
    setLoading(true)
    form
      .validateFields()
      .then(async values => {
        try {
          const res = await AuthService.login({ ...values })
          const {
            success: {
              token,
              role,
              roles,
              permissions,
              level,
              commission_percent,
            },
          } = res
          setStorageCookie(STORAGE.TOKEN, token)
          setStorage(STORAGE.USER_INFO, role)
          localStorage.setItem(STORAGE.ROLES, roles)
          localStorage.setItem(STORAGE.PERMISSIONS, permissions)
          localStorage.setItem(STORAGE.LEVEL, level)
          localStorage.setItem(STORAGE.COMMISSION_PERCENT, commission_percent)
          setLoading(false)
          if (record && roles === "STAFF") {
            // Sau khi login thành công, chuyển về trang đặt hàng
            return navigate(`/detail-sim/${record.ID}`)
          }
          if (selectedPackage && roles === "STAFF") {
            // Sau khi login thành công, chuyển về trang đặt hàng
            return navigate(ROUTER.SALES_BUY_PACKAGE, {
              state: { ...selectedPackage },
            })
          }
          if (
            !permissions.includes("system.htc") &&
            permissions.includes("system.poolData")
          ) {
            dispatch(setMenuType("pullData"))
            if (permissions.includes("poolData.reportOverview.list")) {
              navigate(ROUTER.GENERAL_REPORT_POOL_DATA)
            } else {
              navigate(ROUTER.HOME_PAGE)
            }
          }
          if (
            permissions.includes("system.htc") &&
            !permissions.includes("system.poolData")
          ) {
            dispatch(setMenuType("admin"))
            return navigate(ROUTER.DASHBOARD)
          }
          if (roles === "ADMIN" && permissions.includes("system.htc")) {
            dispatch(setMenuType("admin"))
            return navigate(ROUTER.DASHBOARD)
          }
          if (roles === "STAFF") {
            return navigate(ROUTER.DASHBOARDB2C)
          }
          if (roles !== "CUSTOMER") {
            navigate(ROUTER.HOME_PAGE)
          }

          form.resetFields()
          onClose()
        } catch (err) {
          const {
            response: { data },
          } = err
          setLoading(false)
          form.setFields([
            {
              name: "password",
              errors: [data?.message],
            },
          ])
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }
  return (
    <Form onFinish={onLogin} form={form} layout="vertical">
      {/* <Form.Item name="username" label="Tài khoản" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="password" label="Mật khẩu" rules={[{ required: true }]}>
        <Input.Password />
      </Form.Item>
      <Button type="primary" htmlType="submit" block>
        Đăng nhập
      </Button> */}
      <Form.Item
        label={"Email"}
        required
        rules={[
          {
            required: true,
            message: "Bạn chưa nhập tên email!",
          },
          {
            pattern: /^.{5,}$/,
            message: "Email từ 5 ký tự trở lên",
          },
        ]}
        name="username"
      >
        <BlockInput>
          <SvgIcon name={"user_login"} />
          <Input maxLength={50} size={"large"} placeholder="Nhập email" />
        </BlockInput>
      </Form.Item>
      <Form.Item
        label={"Mật khẩu"}
        rules={[
          {
            required: true,
            message: "Bạn chưa nhập mật khẩu!",
          },
          {
            pattern: /^.{6,}$/,
            message: "Mật khẩu gồm 6-30 ký tự",
          },
        ]}
        name="password"
      >
        <BlockInput>
          <SvgIcon name={"lock_login"} />
          <Input.Password
            size={"large"}
            maxLength={30}
            placeholder="Nhập mật khẩu"
          />
        </BlockInput>
      </Form.Item>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Form.Item name="remember" valuePropName="checked" noStyle>
          <Checkbox
            onChange={val => {
              setStorageCookie(
                STORAGE.REMEMBER_LOGIN,
                JSON.stringify(val.target.checked),
              )
            }}
            checked={getStorage(STORAGE.REMEMBER_LOGIN)}
          >
            Giữ tôi luôn đăng nhập
          </Checkbox>
        </Form.Item>
        <span
          onClick={() => setActiveTab("forgot")}
          className="text-primary"
          role="button"
          style={{ fontSize: "14px", cursor: "pointer", color: "#0d6efd" }}
        >
          Quên mật khẩu?
        </span>
      </div>
      <ButtonStyle
        loading={loading}
        btnType="primary"
        type="submit"
        htmlType="submit"
      // onClick={onLogin}
      >
        Đăng nhập
      </ButtonStyle>
    </Form>
  )
}

export default LoginForm
